export const graphProdURL = 'https://atlassian-graph.prod-east.frontend.public.atl-paas.net/';
export const graphStgURL = 'https://atlassian-graph.stg-east.frontend.public.atl-paas.net/';
